import { FunctionComponent as F, ReactNode } from "react";
import { useSelector } from 'react-redux';
import { Typography, Stack, Box } from '@mui/material';
import { IState } from "../../core/store/store";
import TextTooltip from "../UI/Tooltip/TextTooltip";
import Discounts from "../UI/Button/Discounts";
import { toggleDiscountsAsync } from "../../core/store/listings/listings.thunks";
import { useAppDispatch } from "../../core/store/hooks";
import priceUpdateStatusLines from "./priceUpdateStatusLines";
import UpdatePrice from "../UI/Button/UpdatePrice";


interface Props
{
  listingId: number;
}

const ListedPrice: F<Props> = (props: Props) =>
{
  const appDispatch = useAppDispatch();

  const username = useSelector((state: IState) => state.user.username);

  const listing = useSelector((state: IState) => state.listings.listings
    ?.find(l => l.listingId === props.listingId));
  const discountedPrice = useSelector((state: IState) => state.listings.listings
    ?.find(l => l.listingId === props.listingId)?.discountedPrice);

  if(!listing)
    return <></>;

  const tooltipText: ReactNode[] = [];

  if(listing.deliveryPerListing)
  {
    tooltipText.push("Includes " +
      listing.listingCurrencySymbol + " " +
      listing.deliveryPerListing.toFixed(2) + " " +
      "delivery charge per product");
  }
  if(listing.scrapeTime)
  {
    tooltipText.push(priceUpdateStatusLines(listing.scrapeTime));
  }

  const formattedPriceWithDeliveryPerListing = (price?: number) => price === undefined ?
    "-" :
    listing.listingCurrencySymbol + " " + (price + (listing.deliveryPerListing || 0)).toFixed(2);

  return(
    <Stack direction='row' spacing={0.5} sx={{ display: 'flex', alignItems: 'center' }}>
      <TextTooltip
        lines={tooltipText}
        tooltipPlacement='bottom-start'>
        <Box>
          <Typography variant='body2' sx={discountedPrice !== listing.price ?
            { textDecoration: 'line-through', color: 'red' } :
            {}}>
            {formattedPriceWithDeliveryPerListing(listing.price)}
          </Typography>
          {(discountedPrice && discountedPrice !== listing.price) ?
          <Typography variant='body2'>
            {formattedPriceWithDeliveryPerListing(discountedPrice)}
          </Typography> :
          <></>}
        </Box>
      </TextTooltip>
      {username ? <UpdatePrice listingId={listing.listingId}/> : <></>}
      {listing.discounts?.length ?
        <Discounts
          listingId={listing.listingId}
          toggleDiscountsAsync={async(discountIds: number[]) =>
            appDispatch(toggleDiscountsAsync(listing.listingId, discountIds))}/> :
        <></>}
    </Stack>);
};

export default ListedPrice;
